/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import EnterpriseComponentsConfigRenderer from 'bundles/page-config-common/components/EnterpriseComponentsConfigRenderer';
import { useComponentsConfig } from 'bundles/page-config-common/contexts/ComponentsConfigContext';
import ProgramForceSSONotification from 'bundles/unified-home-common/components/enterprise/ProgramForceSSONotifications';
import NotificationModuleRenderer from 'bundles/unified-home-common/module-renderers/NotificationModuleRenderer';
import EnterpriseBannerNonConfigurable from 'bundles/unified-home-common/pages/enterprise/EnterpriseBannerNonConfigurable';

const EnterpriseHomePageRootContent = () => {
  const pageConfigComponents = useComponentsConfig();

  return (
    <React.Fragment>
      <NotificationModuleRenderer />
      <EnterpriseBannerNonConfigurable isProgramDetailsView={true} shouldShowJoinButton={false} />
      <ProgramForceSSONotification />
      <div data-testid="enterprise-home-page">
        <EnterpriseComponentsConfigRenderer pageConfigComponents={pageConfigComponents} />
      </div>
    </React.Fragment>
  );
};

export default EnterpriseHomePageRootContent;
